import { IconProps } from '@hcs/types';

import { useIcon } from '../../../hooks';

import AcquisitionExplorer from './AcquisitionExplorerIcon.svg?react';
import AgileEvaluation from './AgileEvaluationIcon.svg?react';
import AgileInsights from './AgileInsightsIcon.svg?react';
import AgileSuite from './AgileSuiteIcon.svg?react';
import AppraisalCompareReport from './AppraisalCompareReportIcon.svg?react';
import Bpo from './BpoIcon.svg?react';
import BulkHpi from './BulkHpiIcon.svg?react';
import BulkPropertyData from './BulkPropertyDataIcon.svg?react';
import CanaryAI from './CanaryAIIcon.svg?react';
import DataExplorer from './DataExplorerIcon.svg?react';
import DeveloperCenter from './DeveloperCenterIcon.svg?react';
import HomeMagnifyingGlass from './HomeMagnifyingGlassIcon.svg?react';
import Inspections from './InspectionsIcon.svg?react';
import MarketInsights from './MarketInsightsIcon.svg?react';
import MarketPulse from './MarketPulseIcon.svg?react';
import Platform from './PlatformIcon.svg?react';
import Portfolio from './PortfolioIcon.svg?react';

export const AcquisitionExplorerIcon = (props: IconProps) =>
  useIcon(AcquisitionExplorer, props);
export const AgileEvaluationIcon = (props: IconProps) =>
  useIcon(AgileEvaluation, props);
export const AgileInsightsIcon = (props: IconProps) =>
  useIcon(AgileInsights, props);
export const AgileSuiteIcon = (props: IconProps) => useIcon(AgileSuite, props);
export const AppraisalCompareReportIcon = (props: IconProps) =>
  useIcon(AppraisalCompareReport, props);
export const DataExplorerIcon = (props: IconProps) =>
  useIcon(DataExplorer, props);
export const DeveloperCenterIcon = (props: IconProps) =>
  useIcon(DeveloperCenter, props);
export const HomeMagnifyingGlassIcon = (props: IconProps) =>
  useIcon(HomeMagnifyingGlass, props);
export const InspectionsIcon = (props: IconProps) =>
  useIcon(Inspections, props);
export const PortfolioIcon = (props: IconProps) => useIcon(Portfolio, props);
export const MarketInsightsIcon = (props: IconProps) =>
  useIcon(MarketInsights, props);
export const CanaryAIIcon = (props: IconProps) => useIcon(CanaryAI, props);
export const BpoIcon = (props: IconProps) => useIcon(Bpo, props);
export const BulkPropertyDataIcon = (props: IconProps) =>
  useIcon(BulkPropertyData, props);
export const BulkHpiIcon = (props: IconProps) => useIcon(BulkHpi, props);
export const BulkRpiIcon = (props: IconProps) => useIcon(BulkHpi, props);
export const MarketPulseIcon = (props: IconProps) =>
  useIcon(MarketPulse, props);
export const PlatformIcon = (props: IconProps) => useIcon(Platform, props);
